import { render, staticRenderFns } from "./CoreValues.vue?vue&type=template&id=01022b93&scoped=true"
import script from "./CoreValues.vue?vue&type=script&lang=js"
export * from "./CoreValues.vue?vue&type=script&lang=js"
import style0 from "./CoreValues.vue?vue&type=style&index=0&id=01022b93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01022b93",
  null
  
)

export default component.exports